import {ContentBlocks_Header as HeaderType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/content_blocks.types';
import {
  ContentBlockImageTile,
  ContentBlockImageTileLogo,
  RowSection,
  tabletAndUpLinaria,
  TeaserTextWrapper,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc from 'styled-components';
import {alignmentMap, fontMap, transformImage} from '../transforms';

export const Header: React.FC<{
  content: HeaderType;
  blockId?: number;
  testId?: string;
}> = ({content, blockId, testId = 'customPageHeader'}) => {
  return (
    <StyledRowSection
      $backgroundColor={content.backgroundColor}
      constrained
      data-content-block={blockId}
    >
      <StyledContentBlockImageTile
        testId={testId}
        image={transformImage(content.image)}
        importance="high"
        content={{
          headlines: {
            text: content.headline.text,
            color: content.headline.color,
            size: fontMap[content.headline.size],
            alignment: alignmentMap[content.headline.alignment],
            tag: 'h1',
          },
          sublines: content.subline && {
            text: content.subline.text,
            color: content.subline.color,
            size: fontMap[content.subline.size],
            alignment: alignmentMap[content.subline.alignment],
          },
          logo: content.logo && transformImage(content.logo),
        }}
      />
    </StyledRowSection>
  );
};

const StyledRowSection = linariaStyled(RowSection)<{$backgroundColor?: string}>`
  background-color: ${({$backgroundColor}) => $backgroundColor ?? ''};
  display: flex;
  justify-content: center;

  .imageBackgroundWrapper {
    align-items: center;
    display: flex;
    justify-content: center;
    max-height: 450px;
  }

  min-height: 375px;
  ${tabletAndUpLinaria('min-height: 450px;')};
`;

const StyledContentBlockImageTile = sc(ContentBlockImageTile)`
  ${ContentBlockImageTileLogo} {
    height: auto;
  }
  ${TeaserTextWrapper} {
    gap: 0.5rem;
  }
`;
